import * as React from 'react';
import { useState } from 'react';
import { Paper, Typography } from '@mui/material';
import { useSelector } from '../../store/store';
import Log from '../../lib/log';
import { formatNumber } from '../../functions/Utils';
import SetupTransfer from '../molecules/SetupTransfer';

// ログの初期化
const log = new Log('LectureSetupTransfer');

export default function LectureSetupTransfer() {
  log.putLog('info', 'LectureSetupTransfer started.');
  const [setupUser] = useState(useSelector((state) => state.setupUser));

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
      }}
    >
      <Typography variant='h6' gutterBottom component='div' color={'gray'}>
        続いて、皆さんの携帯電話や固定電話から
        {formatNumber(setupUser.serviceNumber)}
        に転送する方法について説明します。
      </Typography>
      <SetupTransfer
        id={setupUser.id}
        token={setupUser.token}
        serviceNumber={setupUser.serviceNumber}
      />
    </Paper>
  );
}
